'use client';
import classNames from 'classnames';
import { Editor } from '@tiptap/react';
import AttributesDropdown from './TextEditorToolbar/AttributesDropdown';
import {
  CSSProperties,
  forwardRef,
  HTMLAttributes,
  MutableRefObject,
  useEffect,
  useState,
} from 'react';

interface FloatingAttributesDropdownProps extends HTMLAttributes<HTMLDetailsElement> {
  isOpen?: boolean;
  dropdownStyles?: CSSProperties | undefined;
  dropdownClassName?: string;
  editor: Editor | null;
}

const FloatingAttributesDropdown = forwardRef<
  HTMLDivElement,
  FloatingAttributesDropdownProps
>(({ className, style, dropdownStyles, dropdownClassName, editor, isOpen }, ref) => {
  const [cursorPos, setCursorPos] = useState({ top: 0, left: 0 });
  useEffect(() => {
    const refEl = (ref as MutableRefObject<HTMLDivElement | null>)?.current;
    if (!editor || !refEl) {
      return;
    }

    const { from } = editor.state.selection;
    const coords = editor.view.coordsAtPos(from);

    const { top, left } = refEl.getBoundingClientRect();
    setCursorPos({
      top: coords.top - top + 95, // Adjust based on the parent container's top and some buffer
      left: coords.left - left + 14, // Adjust based on the parent container's left and some buffer
    });
  }, [editor, editor?.state.selection, ref]);

  return (
    <details
      className={classNames('dropdown fixed z-20', className)}
      style={{
        top: `${cursorPos.top}px`,
        left: `${cursorPos.left}px`,
        ...style,
      }}
      open={isOpen}
      data-dropdown-dismiss="true">
      <summary
        tabIndex={-1}
        className="btn btn-ghost btn-xs !h-[1px] !min-h-0 !w-[1px] !p-0"></summary>
      <AttributesDropdown
        editor={editor}
        style={dropdownStyles}
        className={dropdownClassName}
        isOpen={isOpen}
        shouldRemoveSlashAfterSelection
      />
    </details>
  );
});

FloatingAttributesDropdown.displayName = 'FloatingAttributesDropdown';
export default FloatingAttributesDropdown;
